﻿import checkoutService from '../../api/checkout';

export default {
    name: 'credit-check',
    mounted() {
        this.validateCustomerCredit();
    },
    data: () => ({
		message: ''
    }),
	props: ['blockid', 'apiurl', 'phonecallunderwritingtext'],
    methods: {
        validateCustomerCredit() {
            var self = this;
            const parameters = { currentBlockId: this.blockid };
            checkoutService.saveInfo(this.apiurl,
                parameters,
                (data) => {
                    if (!data.Success) {
                        if (data.IsOnline) {
                            this.$store.dispatch('updateValidState', { invalid: true, blockId: this.blockid });
                            this.$store.dispatch('isBadPayer', { isBadPayer: true, header: '', body: data.Message, footer: '', hideButton: true });
                        } else if (data.IsUnderWriting) {
							var modalOptions = [{ text: data.ButtonName || 'Email', header: '', action: 'post', url: data.SendEmailUrl }, { text: 'Telefon', header: '', body: self.phonecallunderwritingtext, action: 'noop', url: '' }]
                            this.$store.dispatch('showAlert', { size: 'large', header: data.UnderwritingText, body: data.Message, footer: '', hideButton: false, blockId: this.blockid, options: modalOptions });
                        } else {
                            var modalOptions = [{ text: data.ButtonName, action: 'redirect', url: data.RedirectPageUrl }]
                            this.$store.dispatch('showAlert', { size: 'large', header: '', body: data.Message, footer: '', hideButton: false, options: modalOptions });
                        }
                    }
                },
                (data) => { this.message = data.Message }
            );
        }
    }
}
